import { localDataSelector, makeNullSafeDomainGetter } from './common';
import { flow } from 'lodash';

export const localDataInfoSelector = makeNullSafeDomainGetter(localDataSelector, 'docId2Information');
export const localDataDocSelector = flow(localDataInfoSelector, (info) => info && info.document);
